/**
 * Lazy boundary for the Stripe Elements form. BillingPage ships in the boot
 * bundle (it's a HomePage-switch target), but the Stripe React bindings only
 * matter once a user opens the top-up sheet / add-card flow — so the real
 * `stripe-elements.tsx` (and the `stripe` manualChunk it anchors) loads on
 * first render of this wrapper, not at boot. Same named export + props, so
 * consumers just import from './stripe-elements-lazy'.
 */

import { Skeleton } from '@ordo/ui/skeleton'
import { lazy, type ReactElement, Suspense } from 'react'

import type { StripeElementsFormProps } from './stripe-elements'

const StripeElementsFormInner = lazy(async () => ({
  default: (await import('./stripe-elements')).StripeElementsForm,
}))

export function StripeElementsForm(props: StripeElementsFormProps): ReactElement {
  return (
    <Suspense
      fallback={
        <div className="flex flex-col gap-3">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-10 w-32" />
        </div>
      }>
      <StripeElementsFormInner {...props} />
    </Suspense>
  )
}
